import { NavigateFunction } from 'react-router';

let navigateFn: NavigateFunction | undefined;

export const setNavigate = (fn: NavigateFunction) => {
  navigateFn = fn;
};

export const getNavigate = () => navigateFn;
